import { useContext , createContext, useState, useMemo } from "react"
import { toast } from "react-toastify";
import SummaryApi from "../common";

export const AdminContext = createContext();

const AdminContextProvider = ({children}) =>{
    const [users,setUser] = useState([]);
    const [isLoading,setLoading] = useState(true);

    //pagination related 
    const [currentPage,setCurrentPage] = useState(1);
    const [userPerPage,setUserPerPage] = useState(10);

    const paginationData = useMemo(()=>{
        
        const totalPages = Math.ceil(users.length/userPerPage);
        const startIndex = (currentPage - 1) * userPerPage;
        const endIndex = currentPage * userPerPage;

        const paginatedUser = users.slice(startIndex,endIndex);

        return{
            totalPages,
            paginatedUser,
            totalUser:users.length
        }
    },[users,currentPage,userPerPage]); // if any chnage run useMemo

    const movetoPage = (pageNo) =>{
        setCurrentPage(pageNo)
    }

    const goPrevPage = () =>{
        setCurrentPage((prevPage) => {
            if(prevPage > 1){
                return prevPage - 1; 
            }
        })
    }

    const goNextPage = () =>{
        setCurrentPage((prevPage) => {
            if(prevPage < paginationData.totalPages){
                return prevPage + 1
            }
        })
    } 




    //utility method 
    const sortByLatest = (newData) =>{
        newData.sort((a,b)=>{
            return new Date(b.updatedAt) - new Date(a.updatedAt);
        })

        return newData;
    }
    const getAllUser = async()=>{
        setLoading(true);
        try{
            const response = await fetch(SummaryApi.getAllUser.url,{
                method: SummaryApi.getAllUser.method,
                headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            })
    
            const data = await response.json();
            if(!response.ok){
                toast.error(data.message);
                console.log('failed to fetch data',data.message);
            }
            setUser(data.users);
            console.log(data.users)
            setLoading(false);
        }catch(err){
            toast.error('error fetching user');
            console.log('error in fetching users',err);
            setLoading(false);
        }
    }
    const updateUser = async(userData)=>{
        console.log(userData);
        try{
            if(!userData._id) console.log('provide id');
            const response = await fetch(SummaryApi.updateUser(userData._id).url,{
                method:SummaryApi.updateUser(userData._id).method,
                headers:{
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,                
                },
                body: JSON.stringify(userData)
            })
            const data = await response.json();
            if(!response.ok){
                console.log('failed to fetch data');
                toast.error(data.message);
                return;
            }
            console.log('data is ', data.user);
            toast.success(data.message);
            setUser((prevState)=>{
                const newData = prevState.map((user)=> user._id == data.user._id ? {...user,...data.user}: user);
                
                return sortByLatest(newData);
            })

            getAllUser();//side effect provide data consistency 
        }catch(err){
            console.log('error updating user',err);
            toast.error('error updating user');
        }
    }

    const getAdminUser = async()=>{
        setLoading(true);
        try{
            const response = await fetch(SummaryApi.getAdminUser.url,{
                method:SummaryApi.getAdminUser.method,
                headers:{
                    "Content-Type":"application/json",
                    Authorization: `Bearer ${localStorage.getItem('authToken')}`
                }
            })
            const data = await response.json();
            if(!response.ok){
                console.log(data.message);
                // toast.error(data.message);
                return;
            }
            console.log(data.users);
            setUser(data.users);
        }catch(err){
            console.log('error feching user');
            toast.error('error fecthing user');
        }finally{
            setLoading(false);
        }
    }



    const deleteUser = async(userId)=>{
        try{
            const response = await fetch(SummaryApi.deleteUser(userId).url,{
                method:SummaryApi.deleteUser(userId).method,
                headers:{
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,                
                },
            })

            const data = await response.json();

            if(!response.ok){
                toast.error(data.message);
                console.log(data.message);
                return;
            }
            console.log(data.message);
            setUser((prevState)=>(prevState.filter((user)=> user._id != userId)));
            setTimeout(()=>{
                toast.success(data.message);
            },400)
        }catch(err){
            console.log('error deleting user');
            toast.error('error deleting user');            
        }
    }
    return (
        <AdminContext.Provider value={
            {
                paginatedUser:paginationData.paginatedUser,
                totalPages:paginationData.totalPages,
                totalUsers:paginationData.totalUser,
                currentPage,
                isLoading,
                userPerPage,
                users,
                setUserPerPage,
                movetoPage,
                goPrevPage,
                getAllUser,
                goNextPage,
                getAdminUser,
                updateUser,
                deleteUser
            }}>
            {children}
        </AdminContext.Provider>
    )
}

export default AdminContextProvider;